import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { CoreEffects } from 'angular-engine/engine/state/effect/core.effects';
import { StaticContainer } from 'angular-shared-features/feature/shared-component/static-container.component';

@Component({
  selector: 'app-profile-container',
  templateUrl: './profile-container.template.html',
  styleUrls: ['./profile-container.style.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProfileContainer extends StaticContainer {
  private hasSocialLinks(item:any): boolean {
    let _ = item.template_fields || {};
    return _.facebook || _.twitter || _.instagram || _.youtube || _.website || _.related_map;
  }
}


// WEBPACK FOOTER //
// ./src/angular-framework-client-components/containers/profile-container/profile-container.component.ts